import {ExportedRun} from "./reportStoreApi";

/**
 * Starting the download the server prepared.
 *
 * THE BYTES DO NOT COME THROUGH THE API. The server writes the file to S3 and answers with a short
 * presigned URL; this follows it. That is the rule the application holds everywhere -- Lambda mints
 * URLs, S3 serves files -- and it is why this module no longer decodes anything.
 *
 * WHAT USED TO BE HERE, because the note is worth more than the code was: the workbook arrived
 * base64 in the JSON body and was decoded into a Blob. It had to be decoded to a BYTE ARRAY rather
 * than handed to Blob as `atob`'s string, because Blob encodes a string as UTF-8 and every byte
 * above 0x7F becomes two -- which corrupts a zip, and a .xlsx is a zip. None of that can go wrong
 * now, because none of it happens: the browser fetches the file from S3 the way it fetches any
 * other file.
 *
 * NOTHING HERE NAMES THE FILE EITHER. `anchor.download` is IGNORED for a cross-origin URL, which an
 * S3 link always is -- so the name comes from the `Content-Disposition` the server asked S3 to
 * return, set when the URL was signed. Setting `download` here as well would look like it was doing
 * the work and would quietly stop mattering.
 */
export function saveExported(exported: ExportedRun): void {
    // AN ANSWER THAT IS NOT A DOWNLOAD. If this page is ever newer than the API behind it, the old
    // GET ignores `Export` and answers the list of saved reports -- a 200 with no link. Without
    // this the browser navigates to `undefined` and leaves the report builder, which looks like the
    // application crashing rather than one deployed out of order. It came within one deploy of
    // happening in the base64 version, and the hazard did not go away with the bytes.
    if (!exported?.Url) throw new Error("no download link in the response");

    const anchor = document.createElement("a");
    anchor.href = exported.Url;
    // NOT _blank. The response carries Content-Disposition: attachment, so the browser saves the
    // file and stays where it is; opening a tab first would leave an empty one behind.
    anchor.rel = "noopener";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}
